import React from "react";
import { useDispatch  } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";

import { scrollToScreen } from '../../features/home/homeSlice';

import CustomLinkButton from "./public/CustomLinkButton";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  links: {
    flexGrow: 1,
  },
}));

export default function NavOld() {
  const dispatch = useDispatch();

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
          >
            <MenuIcon />
          </IconButton>
          <div className={classes.links}>
            <CustomLinkButton to="/" onClick={() => dispatch(scrollToScreen(0))}>Inicio</CustomLinkButton>
            <CustomLinkButton to="/" onClick={() => dispatch(scrollToScreen(1))}>Soluções</CustomLinkButton>
            <CustomLinkButton to="/" onClick={() => dispatch(scrollToScreen(2))}>Caracteristicas</CustomLinkButton>
            <CustomLinkButton to="/" onClick={() => dispatch(scrollToScreen(3))}>Modulos</CustomLinkButton>
            <CustomLinkButton to="/" onClick={() => dispatch(scrollToScreen(4))}>Contacto</CustomLinkButton>
            <CustomLinkButton to="/" onClick={() => dispatch(scrollToScreen(5))}>Portfólio</CustomLinkButton>
          </div>
          <CustomLinkButton
            variant="contained"
            color="secondary"
            to="/dashboard"
          >
            Area Cliente
          </CustomLinkButton>
        </Toolbar>
      </AppBar>
    </div>
  );
}
